import type { AsyncSequence } from "../types/AsyncSequence"

export async function IterableToArray<T>(
  ...arrays: AsyncSequence<T>[]
): Promise<T[]> {
  const res = []
  for (const array of arrays) {
    for await (const item of array) {
      res.push(item)
    }
  }
  return res
}

// No default export, only named exports
